import { render, staticRenderFns } from "./TabsDestinationRelationsNoHighlights.vue?vue&type=template&id=3902d55f&"
import script from "./TabsDestinationRelationsNoHighlights.vue?vue&type=script&lang=js&"
export * from "./TabsDestinationRelationsNoHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports